import FallBack from 'Modal/Error/FallBack';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter, Route, Routes  } from 'react-router-dom';
import Interview from './Interview/Interview.lazy';

export default function Modules({ setDownTimeMessage, pageLoaded, setPageLoaded, setTheme }) {
  const errorHandler = (error, errorInfo) => {
    console.log(' Logging ==> ', error, errorInfo);
  };

  return (
    <BrowserRouter>
      <ErrorBoundary FallbackComponent={FallBack} onError={errorHandler}>
        <Routes>
          {Interview.routeProps.map((routeProps, index) => {
            return (
              <Route {...routeProps} key={index}  element={React.cloneElement(routeProps.element, { setDownTimeMessage, pageLoaded, setPageLoaded, setTheme })} />
            );
          })}
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
